import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  DropdownToggle,
  DropdownMenu,
  Nav,
  Button,
  NavItem,
  UncontrolledButtonDropdown,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "react-toastify/dist/ReactToastify.css";
//import logout action
import { logout } from "../../../redux/actions/auth";
//import event bus
import EventBus from "../../../common/EventBus";
import userService from "../../../redux/services/user.service";
import { Link } from "react-router-dom";

const UserBox = (props) => {
  const authDetails = props.authDetails;
  const [avatar, setAvatar] = useState("");
  const [currentUser, setCurrentUser] = useState(authDetails);

  const dispatch = useDispatch();

  const getUser = id => {
    userService.get(id)
      .then(response => {
        setCurrentUser(response.data.userInfo);
        if (response.data.userInfo.profileImage) {
          setAvatar(response.data.userInfo.profileImage
          );
        }
      })
      .catch(error => {
        console.error(`Error in get profile`, error)
      });
  };

  useEffect(() => {
    getUser(authDetails?.publicId)
    if (authDetails && authDetails?.expiry && new Date().getTime() > authDetails?.expiry)
      logOut();
  }, [authDetails]);

  const logOut = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, [logOut]);

  const displayEmail =
    currentUser?.email || authDetails?.email || "";
  const displayName =
    currentUser?.fullName || authDetails?.fullName || "";

  return (
    <>
      <div className="header-btn-lg pe-0">
        <div className="widget-content p-0">
          <div className="widget-content-wrapper">
            <div className="widget-content-left">
              <UncontrolledButtonDropdown>
                <DropdownToggle
                  color="link"
                  className="p-0 d-flex align-items-center text-decoration-none text-body"
                  title={
                    [displayName, displayEmail].filter(Boolean).join(" — ") ||
                    undefined
                  }
                >
                  <img
                    width={42}
                    className="rounded-circle"
                    src={avatar}
                    alt=""
                  />
                  <div className="ms-2 me-1 text-end">
                    {displayName ? (
                      <div className="small fw-semibold text-truncate header-user-name d-none d-sm-block">
                        {displayName}
                      </div>
                    ) : null}
                    {displayEmail ? (
                      <div
                        className="small text-muted text-truncate header-user-email"
                        style={{ maxWidth: "min(42vw, 220px)" }}
                        title={displayEmail}
                      >
                        {displayEmail}
                      </div>
                    ) : null}
                  </div>
                  <FontAwesomeIcon
                    className="ms-1 opacity-8"
                    icon={faAngleDown}
                  />
                </DropdownToggle>
                <DropdownMenu end className="rm-pointers dropdown-menu-lg">
                  <div className="dropdown-menu-header">
                    <div className="dropdown-menu-header-inner bg-info">
                      <div className="menu-header-image opacity-2" />
                      <div className="menu-header-content text-start">
                        <div className="widget-content p-0">
                          <div className="widget-content-wrapper">
                            <div className="widget-content-left me-3">
                              <img
                                width={42}
                                className="rounded-circle"
                                src={avatar}
                                alt=""
                              />
                            </div>
                            <div className="widget-content-left">
                              <div className="widget-heading">
                                {currentUser?.fullName}
                              </div>
                              <div className="widget-subheading opacity-8">
                                {currentUser ? currentUser?.email : ""}
                              </div>
                            </div>
                            <div className="widget-content-right me-2">
                              <Button
                                className="btn-pill btn-shadow btn-shine"
                                color="focus"
                                onClick={logOut}
                              >
                                Logout
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="scroll-area-xs"
                    style={{
                      height: "35px",
                    }}
                  >
                    <PerfectScrollbar>
                      <Nav vertical>
                        <NavItem>
                          <Link className="nav-link py-1 px-3" to="/profile">
                            Edit My Profile
                          </Link>
                        </NavItem>
                      </Nav>
                    </PerfectScrollbar>
                  </div>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default UserBox;
